import React from 'react';
import { NavLink, Link } from 'react-router-dom';
import { HelpCircle } from 'Utils/SvgIcons';
import ReactTooltip from 'react-tooltip';
import {productTypeToUrl} from "Constants/displayConstants";

class SerializedProductNavLink extends React.Component {
  render() {
    const { params, product } = this.props;
    const missingSerialNumbersCount = product?.missingSerialNumbersCount ?? 0;

    return (
      <NavLink
        id='serialized'
        activeClassName='selected'
        to={`/inventory/${productTypeToUrl[product.productType]}/${params.id}/serialized`}
      >
        Serialized
        {missingSerialNumbersCount > 0 && (
          <a
            className='missing-serial-numbers-count-info'
            data-tip
            data-for='missing-serial-numbers-count-info'
            data-event='mouseenter'
            data-event-off='mouseleave'
          >
            <HelpCircle className='lesser-serial-numbers' />
          </a>
        )}
        {missingSerialNumbersCount > 0 && (
          <ReactTooltip
            id='missing-serial-numbers-count-info'
            class='tooltip bottom'
            place='bottom'
            effect='solid'
          >
            <p>
              You need to generate serial numbers for{' '}
              {missingSerialNumbersCount} items.
            </p>
          </ReactTooltip>
        )}
      </NavLink>
    );
  }
}

export default SerializedProductNavLink;
